module.exports = __webpack_public_path__ + "img/gasbot_left.c73a9d8f.png";